import {Component} from '@angular/core';
import {DataGrid} from '../../DoraData/data-grid';
import {DataType} from '../../pusblisher/ipublisher';
import {DataRow} from '../../DoraData/data-row';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {MessageRowsSelected} from '../../messages/message-rows-selected';
import {PreselectElement} from './data/preselect-element';
import {PreselectElements} from './data/preselect-elements';
import {DoraProperty} from '../../Decorators/Decorator';

@Component({
  selector: 'dora-rows-preselect',
  template: ''
})
/**
 * Base widget
 */
export class DoraRowsPreselectComponent extends WidgetBaseGridComponent {
  protected preselectElements: PreselectElements = null;

  @DoraProperty
  private levelMin = 1;
  @DoraProperty
  private levelMax = 1;

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
    super.ngOnInit();

    this.gridIdPostfix = '_Preselect';
    this.flSelectFirstRow = true;
  }

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();
    this.preselectElements = new PreselectElements(this.levelMin, this.levelMax);
  }

  protected onNewData(): void {
    super.onNewData();

    this.preselectElements.loadPreselectElements(this.dataGrid.DataRows);
  }

  protected selectedGrid(rowId: string): void {
    super.selectedGrid(rowId);

    let dataRow: DataRow;
    dataRow = this.dataGrid.getDataRow(rowId);

    if (dataRow === null) {
      console.error('Row not found. Id: ' + rowId);
      return;
    }

    this.dataGrid.selectRowMutex(dataRow.Id);

    const prelesectTableTupla = dataRow.getDataTupla('GridIdRowList');

    let preselectTableName = '';
    if (prelesectTableTupla === undefined) {
      preselectTableName = this.gridId + '_' + rowId + '_RowList';
    } else {
      preselectTableName = prelesectTableTupla.Value;
    }
    // Read row list from specific preselect
    this.read([preselectTableName], DataType.GRID).subscribe((data: any) => {
      const rowsList: DataGrid = (data as DataGrid);

      const idRows: string[] = [];

      // @ts-ignore
      for (const dataRowToSelect: DataRow of rowsList.DataRows) {
        idRows.push(dataRowToSelect.Id);
      }
      this.messageService.sendMessage(this.EventChannel, new MessageRowsSelected(idRows), this.CallerName);
    });
  }
}
